import apiHelper from './Helpers/ApiHelper';

export async function getContext() {
    const response = await apiHelper.get('api/Context/');
    return response.data;
}
